import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import AppBreadcrumb from './AppBreadcrumb';
import profile_image from './resources/images/layout/default_image.jpg';
import {Button} from 'primereact/button';
import {useHistory} from "react-router-dom";
import {Badge} from "primereact/badge";
// import axios from "axios";


const AppTopbar = (props) => {

    let history = useHistory();
    const [persProfilePhoto, setPersProfilePhoto] = useState(profile_image);
    const [unreadMessageCount, setUnreadMessageCount] = useState(null);
    const [unreadNotfCount, setUnreadNotfCount] = useState(null);
    const [userSessionCount, setUserSessionCount] = useState(0);
    const [page, setPage] = useState(0);
    const user_list = !!localStorage.getItem('user_list');
    const user_username = localStorage.getItem("user_username");


    const notificationsItemClassName = classNames('notifications-item', {'active-menuitem': props.topbarNotificationMenuActive});
    const profileItemClassName = classNames('profile-item', {'active-menuitem fadeInDown': props.topbarUserMenuActive});

    useEffect(() => {
        user_session_count()
        const clicked = () => messages(page);
        window.addEventListener("click", clicked)
        const user_username = localStorage.getItem("user_username");
        getPersonProfilePhoto(user_username);

        if (user_list) {

            const clicked2 = () => user_session_count();
            window.addEventListener("click", clicked2)
        }
    }, [])


    const messages = (page) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/messages/" + page + "/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        // setDialog(false)

                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data) {

                            setUnreadMessageCount(data.unreadMessageCount)
                            setUnreadNotfCount(data.unreadNotfCount)

                        } else {

                        }
                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }
    const user_session_count = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/user_session_count/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        // setDialog(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data) {
                            setUserSessionCount(data.user_session_count)
                        } else {

                        }
                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const messageReadCount = () => {

        window.location.hash = '/message'
    }

    const getPersonProfilePhoto = (user_username) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token && user_username !== null) {
            headers["Authorization"] = `Token ${token}`;
            fetch(`/api/user_image/${user_username}/`, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let response = res.data;
                        if (response.pers_photo != null) {
                            setPersProfilePhoto(response.pers_photo);
                        }

                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const userLogout = (event) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch(`api/auth/logout/`, {headers,})
                .then(res => {
                    if (res.status === 204) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("user_username");
                        localStorage.clear();
                        props.logout;
                        window.location.href = "/";
                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    // const toY3Portal = () => {
    //     const host = window.location.host;
    //     if (localStorage.getItem('token')) {
    //         let url = "https://y3portal.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
    //         if (host.includes("localhost"))
    //             url = "http://localhost:8001/authorization?token=" + localStorage.getItem('token')
    //         window.location.replace(url);
    //     } else {
    //         window.location.replace(host);
    //         window.location.replace("https://y3.ssyz.org/login");
    //     }
    // }

    // const toDegirmenPortal = () => {
    //     const host = window.location.host;
    //     if (localStorage.getItem('token')) {
    //         let url = "https://dportal.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
    //         if (host.includes("localhost"))
    //             url = "http://localhost:8004/authorization?token=" + localStorage.getItem('token')
    //         window.location.replace(url);
    //     } else {
    //         window.location.replace(host);
    //         window.location.replace("https://degirmen.ssyz.org.tr/login");
    //     }
    // }

    // const toVeriKovaniPortal = () => {
    //     const token = localStorage.getItem("token");
    //     const headers = {"Authorization": "Token " + token}
    //     const obj = { userName: user_username };
    //     axios.post('/api/vk-token-add/', obj, {"headers": headers})
    //         .then(res => {
    //             const data = res.data
    //             if (data) {
    //                 const host = window.location.host;
    //                 if (localStorage.getItem('token')) {
    //                     let url = "https://vk.ssyz.org.tr/auth/login?YZP-Token=" + localStorage.getItem('token') + "&user=" + user_username;
    //                     if (host.includes("localhost"))
    //                         url = "http://localhost:8004/authorization?token=" + localStorage.getItem('token')
    //                     window.location.replace(url);
    //                 } else {
    //                     window.location.replace(host);
    //                     window.location.replace("https://vkportal.ssyz.org.tr/login");
    //                 }
    //             }
    //         })
    // }

    // const toMEPortal = () => {
    //     const host = window.location.host;
    //     if (localStorage.getItem('token')) {
    //         let url = "https://meportal.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
    //         if (host.includes("localhost"))
    //             url = "http://localhost:8005/authorization?token=" + localStorage.getItem('token')
    //         window.location.replace(url);
    //     } else {
    //         window.location.replace(host);
    //         window.location.replace("https://modelegitim.ssyz.org.tr/login");
    //     }
    // }

    const goMainPage = () => {
        window.location.hash = '/notifications'
    }

    // const toEgitimPortal = () => {
    //     const host = window.location.host;
    //     if (localStorage.getItem('token')) {
    //         let url = "https://egitim.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
    //         if (host.includes("localhost"))
    //             url = "http://localhost:8010/authorization?token=" + localStorage.getItem('token')
    //         window.location.replace(url);
    //     } else {
    //         window.location.replace("https://egitim.ssyz.org.tr/login");
    //     }
    // }

    // const toSimportPortal = () => {
    //     const host = window.location.host;
    //     if (localStorage.getItem('token')) {
    //         let url = "https://simport.ssyz.org.tr/authorization?token=" + localStorage.getItem('token');
    //         if (host.includes("localhost"))
    //             url = "http://localhost:8011/oauth?oauthtoken=" + localStorage.getItem('token')
    //         window.location.replace(url);
    //     } else {
    //         window.location.replace("https://simport.ssyz.org.tr/login");
    //     }
    // }

    const toKiyaslaPortal = () => {
        const host = window.location.host;
        if (localStorage.getItem('token')) {
            let url = "https://ssyz.org.tr/kiyasla";
            if (host.includes("localhost"))
                url = "http://localhost:8012/kiyasla";  window.location.replace(url);
        } else {
            window.location.replace("https://ssyz.org.tr");
        }
    }

    const toEvrenPortal = () => {
        const host = window.location.host;
        if (localStorage.getItem('token')) {
            let url = "https://ssyz.org.tr/evren";
            if (host.includes("localhost"))
                url = "http://localhost:8013/evren";
            window.location.replace(url);
        } else {
            window.location.replace("https://ssyz.org.tr");
        }
    }

    const toGpuTalepPortal = () => {
        const host = window.location.host;
        if (localStorage.getItem('token')) {
            let url = "https://ssyz.org.tr/gputalep" ;
            if (host.includes("localhost"))
                url = "http://localhost:8014/gputalep";
            window.location.replace(url);
        } else {
            window.location.replace("https://ssyz.org.tr");
        }
    }


    return (


        <div className="layout-topbar">
            <div className="topbar-left">
                <Button
                    icon="pi pi-ellipsis-v"
                    className="p-button-rounded p-button-secondary p-button-outlined"
                    aria-label="Bookmark"
                    tooltip="Menüyü Kapat"
                    onClick={props.onMenuButtonClick}/>

                <span className="topbar-separator"/>

                <div className="layout-breadcrumb viewname" style={{textTransform: 'uppercase'}}>
                    <AppBreadcrumb routers={props.routers}/>
                </div>


            </div>


            <div className="topbar-right">

                <ul className="topbar-menu">
                    {/*<li className="search-item">*/}

                    {/*    <Button label="Portal Ana Sayfasına Git" className="p-button-rounded p-button-info"*/}
                    {/*            onClick={() => window.open('https://ssyz.org.tr/', '_blank')}*/}
                    {/*            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}*/}
                    {/*    />*/}


                    {/*</li>*/}
                    {/*<li className="search-item">*/}
                    {/*    <Button label="Y3 Portale Git" className="p-button-rounded p-button-danger"*/}
                    {/*            onClick={() => window.open('https://y3portal.ssyz.org.tr/#/main', '_blank')}*/}
                    {/*            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}*/}
                    {/*    />*/}
                    {/*    /!* <img src={profile_image2} style={{width:'25%'}} onClick={() => window.open('https://y3portal.ssyz.org.tr/#/main', '_blank')}/>*!/*/}
                    {/*    /!*<img src={profile_image} style={{width:'25%'}} onClick={() => window.open('https://y3portal.ssyz.org.tr/#/main', '_blank')}/>*!/*/}


                    {/*</li>*/}

                    <li>{
                        user_list ?
                            <Button type="button" label="Aktif Kullanıcı" icon="pi pi-users"
                                    className="p-button-text p-button-raised p-button-rounded" disabled><Badge
                                value={userSessionCount} severity="info"
                                style={{
                                    fontSize: '1rem',
                                    minWidth: '1.8rem',
                                    height: '1.8rem',
                                    lineHeight: '1.8rem'
                                }}/></Button> :
                            null
                    }

                    </li>
                    <li className={notificationsItemClassName}>
                        <Button tooltip="Bildirimler" type="button" className="p-link"
                                onClick={() => goMainPage()}
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}>
                            <i className="pi pi-bell"/>
                            <span className="topbar-badge">{unreadNotfCount}</span>
                        </Button>
                    </li>

                    <li className={notificationsItemClassName}>
                        <Button tooltip="Mesajlar" type="button" className="p-link"
                                onClick={() => messageReadCount()}
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                        >
                            <i className="pi pi-comments"/>
                            <span className="topbar-badge">{unreadMessageCount}</span>

                        </Button>

                    </li>

                    <li className={profileItemClassName}>
                        <button type="button" className="p-link" onClick={props.onTopbarUserMenu}>
                            <img src={persProfilePhoto} alt="profil"
                                 className="profile-image"
                                 style={{borderRadius: '50%', maxWidth: 130, maxHeight: 130}}
                            />
                            <span
                                className="profile-name">{localStorage.getItem('pers_name')} </span> &nbsp;
                            <span>{localStorage.getItem('pers_surname')}</span>
                        </button>
                        <ul className="profile-menu fade-in-up">
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => window.open('https://ssyz.org.tr/', '_self')}>
                                    <i className="pi pi-desktop"/>
                                    <span>Platform Ana Sayfasına Git</span>
                                </button>
                            </li>
                            {/* <li>
                                <button type="button" className="p-link"
                                        onClick={() => toY3Portal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Y3 Portale Git</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => toMEPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Model Eğitim Portale Git</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => toDegirmenPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Değirmen Portale Git</span>
                                </button>
                            </li>
                             <li>
                                <button type="button" className="p-link"
                                        onClick={() => toVeriKovaniPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Veri Kovanı Portale Git</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => toEgitimPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Eğitim Portaline Git</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => toSimportPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Simülasyon Portaline Git</span>
                                </button>
                            </li> */}
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => toKiyaslaPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Kıyasla Portalına Git</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => toEvrenPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>Evren Portalına Git</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => toGpuTalepPortal()}
                                >
                                    <i className="pi pi-external-link"/>
                                    <span>GPU Talep Portalına Git</span>
                                </button>
                            </li>

                            <li>
                                <button type="button" className="p-link"
                                        onClick={() => window.location.hash = '#profil'}>
                                    <i className="pi pi-user"/>
                                    <span>Profilim</span>
                                </button>
                            </li>

                            {/*<li>*/}
                            {/*    <button type="button" className="p-link">*/}
                            {/*        <i className="pi pi-cog"></i>*/}
                            {/*        <span>Settings</span>*/}
                            {/*    </button>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <button type="button" className="p-link">*/}
                            {/*        <i className="pi pi-calendar"></i>*/}
                            {/*        <span>Calendar</span>*/}
                            {/*    </button>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <button type="button" className="p-link">*/}
                            {/*        <i className="pi pi-inbox"></i>*/}
                            {/*        <span>Inbox</span>*/}
                            {/*    </button>*/}
                            {/*</li>*/}
                            <li>
                                <button type="button" className="p-link" onClick={userLogout}>
                                    <i className="pi pi-power-off"/>
                                    <span>Güvenli Çıkış</span>
                                </button>
                            </li>
                        </ul>
                    </li>


                    <li className="right-sidebar-item">

                        <Button icon="pi pi-arrow-left"
                                className="p-button-rounded p-button-secondary p-button-outlined"
                                aria-label="Bookmark"
                                tooltip="Geri"
                                onClick={() => history.goBack()}/>
                    </li>
                </ul>


            </div>
        </div>
    );
}

export default AppTopbar;



// WEBPACK FOOTER //
// ./src/AppTopbar.js